import { createContext } from "react";
import { SortingRule } from "react-table";

export default createContext<SortingRule<object>[]>([]);
